import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'recompose'
import _get from 'lodash/get'
import _parseInt from 'lodash/parseInt'
import { Map, List } from 'immutable'
import { getBoundActions } from '../../actions/index'
import { connect as connectStaticText } from '../StaticText/connect'
import { getPrimary } from '../../services/languages/index'
import TileGridV2 from '../TileGrid.v2/index'
import LoadMore from '../LoadMore/index'
import Pager from '../Pager/index'
import BackToTop from '../BackToTop/index'
import { capitalizeFirstLetter } from '../../theme/web-app/index'
import { getFormattedLocaleDate } from '../../services/date-time/index'
import { TYPE_RECENTLY_ADDED } from '../../services/tiles/index'
import {
  STORE_KEY_RECENTLY_ADDED,
} from '../../services/store-keys/index'
import {
  connect as connectPage,
  PAGE_SEO_TYPE_LOCATION,
} from '../Page/connect'
import connectCommentsLoader from '../CommentsLoader/connect'
import { connect as connectTiles } from '../Tiles/connect'
import { connect as languageConnect } from '../Language/connect'
import {
  SCREEN_TYPE_RECENTLY_ADDED,
  createUpstreamContext,
} from '../../services/upstream-context/index'
import { H1, H6 } from '../Heading/index'

function createOnLanguageChange (actions) {
  return actions.tiles.resetTilesData
}

function getTilesState (storeKey, props) {
  const { tiles } = props
  return tiles
}

function getCurrentPage (props) {
  const { location } = props
  return _parseInt(_get(location, ['query', 'page']))
}

function renderTileRows (props, storeKey) {
  const tilesState = getTilesState(storeKey, props)
  if (!tilesState.get('data')) {
    return null
  }

  const titles = tilesState.getIn(['data', 'titles'], List()) || List()
  const orderedTitles = titles.sort((a, b) => b.get('created') - a.get('created'))

  return (
    <TileGridV2
      key={'tilegrid-recently-added'}
      tileData={orderedTitles}
      adminTitle={'Recently Added Page'}
      upstreamContext={createUpstreamContext({
        screenType: SCREEN_TYPE_RECENTLY_ADDED,
        storeKey: STORE_KEY_RECENTLY_ADDED,
      })}
      uiLocation="New Videos"
    />
  )
}

class RecentlyAddedPage extends Component {
  componentDidMount () {
    const { props } = this
    const { page, recentlyAdded, getRecentlyAddedData } = props
    const locale = page.get('locale')
    if (recentlyAdded.size === 0) {
      getRecentlyAddedData(locale)
    }
  }

  onClickLoadMore = (e) => {
    const { props } = this
    const { getTilesDataLoadMore } = props

    getTilesDataLoadMore(e)
  }

  render () {
    const { props, onClickLoadMore } = this
    const {
      recentlyAdded,
      user,
      location,
      history,
      children,
      tiles,
      staticText,
    } = props
    const placeholderTitlesExist = tiles.get('placeholderTitlesExist')
    const titlesCount = tiles.getIn(['data', 'titles'], List()).size
    const totalTilesCount = tiles.getIn(['data', 'totalCount'], 0)
    const totalPages = tiles.getIn(['data', 'totalPages'], 0)
    const processing = tiles.get('processing')
    const queryPage = getCurrentPage(props)
    const currentPage = queryPage || 1
    const currentTime = recentlyAdded.getIn(['data', 'currentTime'])
    const userLanguage = getPrimary(user.getIn(['data', 'language']))
    const today = getFormattedLocaleDate(currentTime, userLanguage)
    return (
      <div className="recently-added-page">
        <header className="recently-added-page__header">
          <H6 className="recently-added-page__date">{capitalizeFirstLetter(today)}</H6>
          <H1 className="recently-added-page__title">
            {staticText.getIn(['data', 'newOnGaia'])}
          </H1>
          <p className="recently-added-page__intro">
            {staticText.getIn(['data', 'stayUpToDate'])}
          </p>
        </header>
        {renderTileRows(props, TYPE_RECENTLY_ADDED)}
        {children}
        <div className="recently-added-page__bottom">
          {
            placeholderTitlesExist
            || processing
            || totalPages < 2
            || currentPage === totalPages
            || currentPage !== 1 ? null
              : (
                <LoadMore
                  onLoadMore={onClickLoadMore}
                  buttonClassName={[
                    'recently-added-page__load-more-button',
                    'button--secondary',
                  ]}
                  currentCount={titlesCount}
                  totalCount={totalTilesCount}
                  processing={processing}
                  infiniteScroll
                />
              )
          }
          {
            placeholderTitlesExist
            || processing
            || (currentPage === 1)
            || totalPages < 2 ? null
              : (
                <Pager location={location} history={history} total={totalPages} />
              )
          }
          <BackToTop />
        </div>
      </div>
    )
  }
}

RecentlyAddedPage.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  page: ImmutablePropTypes.map.isRequired,
  tiles: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object.isRequired,
  recentlyAdded: ImmutablePropTypes.map.isRequired,
  getTilesDataLoadMore: PropTypes.func.isRequired,
  getRecentlyAddedData: PropTypes.func.isRequired,
}

export default compose(
  reduxConnect(
    (state) => {
      return {
        tiles: state.tiles.get(STORE_KEY_RECENTLY_ADDED, Map()),
        recentlyAdded: state.recentlyAdded,
        auth: state.auth,
        user: state.user,
        page: state.page,
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        getRecentlyAddedData: actions.recentlyAdded.getRecentlyAddedData,
      }
    },
  ),
  connectCommentsLoader(),
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectTiles({
    storeKey: STORE_KEY_RECENTLY_ADDED,
    type: TYPE_RECENTLY_ADDED,
    enablePageBehaviors: true,
  }),
  connectStaticText({
    storeKey: 'recentlyAddedPage',
  }),
  languageConnect({ createOnLanguageChange }),
)(RecentlyAddedPage)
